module.exports = __webpack_public_path__ + "static/media/carta_83.012d9257.jpg";